import { Button, Link } from "@trussworks/react-uswds";
import { useContext, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { createSearchParams, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { AnalyticsAction, logEvent } from "../../utils/analytics";
//import { SearchFilters, TypeOfHelp } from "../../types";
import {
  SearchFilters,
  EMPTY_SEARCH_FILTERS,
} from "../../types/v1_schemas";
import ZipInput from "../ZipInput";
import { SurveyTriggerContext } from "../../App";
import TypeOfHelpDropDown from "./TypeOfHelpDropDown";
import locationURL from "../../images/location.svg";
import { ReactComponent as Phone } from "../../images/phone.svg";

import AppAlert from "../AppAlert";
import { getZipSearchMetadata } from "../../utils/search";
import i18n from "../../i18n";
import ReactMarkdown from "react-markdown";
import Vector from "../../images/Vector.png";



const SearchButton = styled(Button)`
  @media (min-width: 580px) {
    
  }
  height: 50px;
  margin-right: 0;
  background-color: var("--lime_green");
  border: 1px solid #1A103F;
  font-family: Comfortaa;
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 26px;
  letter-spacing: -3%;
`;

const StyledZipContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: space-between;

  & > * {
    margin: 0.25rem 0;
  }
  @media (min-width: 770px) {
    flex-direction: row;
    & > * {
      margin: 0 0.25rem;
    }
  }

  & #zip {
    border-radius: 0.25rem;
    height: 3rem;
    background-image: none;
    padding-left: 0.8rem;
    width: 100%;

    @media (min-width: 770px) {
      width: 180px;
    }
  }

  .usa-error-message {
    white-space: normal;
    width: width: 100%;

    @media (min-width: 770px) {
      width: 180px;
    };
  }

  & #zip[value=""] {
    color: #71767a;
    padding-left: 2rem;
    background-image: url(${locationURL});
    background-repeat: no-repeat;
    background-position: left;
    background-position-x: 0.8rem;
    background-color: white!important;
  }
`;

type SearchCardProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

function SearchCard({ isOpen, setIsOpen }: SearchCardProps) {
  const [filters, setFilters] = useState<SearchFilters>(EMPTY_SEARCH_FILTERS);

  const { t } = useTranslation();
  
  const navigate = useNavigate();

  const zipMeta = getZipSearchMetadata(filters.distanceSearchZipCode ?? '');

  // Global application state to track trigger events for showing user
  // option to take site survey
  const { incrementTriggerEventCount } = useContext(SurveyTriggerContext);

  // don't show validation errors until clicking search or clicking out of input
  const [showValidation, setShowValidation] = useState<boolean>(false);
  
  function contactUsClick() {
    setIsOpen(true);
  }

  //console.log("filters", filters);
  return (
    <div style={{"marginTop":"3px"}}>
      {(filters.serviceProvidedIds?.includes(10150060 as never)) && (
        <div className="margin-y-2" id="crisis-content-box">
          <AppAlert Icon={Phone}>
            <ReactMarkdown className="plain_link">{t("suicidalIdeationAlert").replaceAll("\n\n", " ")}</ReactMarkdown>
          </AppAlert>
        </div>
      )}
        
          <div style={{"marginLeft":"7px", marginBottom: "42px"}}>
            <p className="margin-top-0 margin-bottom-2" 
                  style={{"fontWeight":"200", "fontSize":"16px", "marginRight":"5px"}}>
              
              <Trans 
                i18nKey="zipCodePrompt" 
                components={{ link1: <button type="button" 
                  style={{border: "0px ", backgroundColor: "transparent", textDecoration: "underline", cursor: "pointer"}}
                  onClick={contactUsClick}>Contact us</button>}}
              />
            </p>
          </div>
        
      <form
        onSubmit={(evt) => {
          evt.preventDefault();
          if (zipMeta.isValidZip) {
            // US 320837 WIGS: Find time spent finding provider
            const entryTime = Date.now();
            sessionStorage.setItem('searchCardEntryTime', entryTime.toString());
            console.log('sessionStorage searchCardEntryTime is ' + entryTime.toString())

            logEvent(AnalyticsAction.CompleteZipSearch, {
              search: filters.distanceSearchZipCode,
            });
            incrementTriggerEventCount();

            //clean up filter object so url search params makes more sense
            delete filters.displayNameFilter;
            delete filters.openSunday;
            delete filters.openMonday;
            delete filters.openTuesday;
            delete filters.openWednesday;
            delete filters.openThursday;
            delete filters.openFriday;
            delete filters.openSaturday;
            
            navigate({
              pathname: "/search",
              search: createSearchParams({
                ...filters,
                distanceSearchRadiusInMiles: `${zipMeta.distanceSearchRadiusInMiles}`,
                page: '1',
                pageSize: "20",
                language: i18n.language
              }).toString(),
            });
          } else {
            setShowValidation(true);
            logEvent(AnalyticsAction.SearchError, { search: filters.distanceSearchZipCode });
          }


        }}
      >
        <StyledZipContainer>
          <ZipInput
            zip={filters.distanceSearchZipCode ?? ''}
            setZip={(distanceSearchZipCode) => setFilters({ ...filters, distanceSearchZipCode })}
            setDistanceSearchZipCode={(distanceSearchZipCode) => 
              setFilters({
                ...filters,
                distanceSearchZipCode})}
            placeholder={t("zipCode")}
            showError={showValidation}
            noLabel            
          />

          <TypeOfHelpDropDown
            filters={filters}
            setFilters={setFilters}
          />
          <SearchButton type="submit" className="search-button">
            {t("search")}
          </SearchButton>
        </StyledZipContainer>
      </form>
      <br></br>
      <p className="margin-top-1 margin-left-1"><img src={Vector} className="margin-right-2" alt="" ></img>
      <Trans
        i18nKey="noInsuranceRequired"
        components={{ strong: <span style={{fontWeight: "700"}}></span>,
          learnMoreLink: <Link href="/about" rel="noreferrer"
          style={{border: "0px ", backgroundColor: "transparent", textDecoration: "underline", cursor: "pointer", color: "black"}}>x</Link>
        }}
      />
      </p>
    </div>
  );
}

export default SearchCard;
